import { Component } from '@angular/core';

@Component({
  selector: 'app-choose-template-skeleton',
  templateUrl: './choose-template-skeleton.component.html',
  styleUrls: ['./choose-template-skeleton.component.scss']
})
export class ChooseTemplateSkeletonComponent {
  activeCards = [0, 1];
  thumbStrip = [0, 1, 2, 3];
  tagChips = [0, 1, 2, 3];
  catalogCards = [0, 1];
  themeCircles = [0, 1, 2, 3, 4];
}
